import $$ from 'dom7';
import Framework7 from 'framework7/framework7.esm.bundle.js';

// Import F7 Styles
import 'framework7/css/framework7.bundle.css';

// Import Icons and App Custom Styles
import '../css/icons.css';
import '../css/app.css';
// Import Cordova APIs
import cordovaApp from './cordova-app.js';
import server from './server.js';
import lang from './lang.js';
// Import Routes
import routes from './routes.js';

// Import Leaflet
import L from 'leaflet';
import { GeoSearchControl, GoogleProvider }
from 'leaflet-geosearch';
import 'leaflet/dist/leaflet.css';
import 'leaflet-geosearch/assets/css/leaflet.css';

// Import main app component
import App from '../app.f7.html';

window.myApp = {
  request: {
    _req: async (api, data, method, contentType) => {
      const headers = {
        "X-Application-Id": myApp.server.applicationId,
        "X-Auth-Token": myApp.server.token(),
      }
      if(!contentType && ['POST','PUT','PATCH'].indexOf(method) !== -1) {
        headers['Content-Type'] = 'application/json';
      }
      return await fetch('https://rest.dreamgest.com/infomycity/' + api, {
        method: method || 'GET',
        headers: headers,
        body: data ? JSON.stringify(data) : null,
      });
    },
    get: async (api) => {
      return await myApp.request._req(api);
    },
    post: async (api, data) => {
      return await myApp.request._req(api, data, 'POST');
    },
    put: async (api, data) => {
      return await myApp.request._req(api, data, 'PUT');
    },
    patch: async (api, data) => {
      return await myApp.request._req(api, data, 'PATCH');
    },
    head: async (api) => {
      return await myApp.request._req(api, null, 'HEAD');
    },
    delete: async (api) => {
      return await myApp.request._req(api, null, 'DELETE');
    },
  },
  cordova: cordovaApp,
  server: server,
  L: L,
  GeoSearchControl: GeoSearchControl,
  OpenStreetMapProvider: GoogleProvider,
  GeoIcon: L.icon({
    iconUrl: 'static/markers/marker-icon.png',
    iconSize: [25, 41],
    iconAnchor: [12.5, 20.5],
    popupAnchor: [0, 0]
  }),
  uid: localStorage.uid || '',
  latlng: [45.464198, 9.189708], // piazza Duomo, Milano
  realPosition: null,
  searchRadious: 15,
  language: lang,
  aroundLimit: 250,
  badge: {},
  messages: {},
  user: JSON.parse(localStorage.user || '{}'),
  months: {
    en: ('January February March April May June July August September October November December').split(' '),
    it: ('Gennaio Febbraio Marzo Aprile Maggio Gigno Luglio Agosto Settembre Ottobre Novembre Dicembre').split(' '),
    fr: ('Janvier Février Mars Avril Mai Juin Juillet Août Septembre Octobre Novembre Décembre').split(' '),
  },
  avatar: function () {
    return window.myApp.user.img_url || 'static/avatar-1.svg';
  },
  setUser: function (data) {
    window.myApp.user = data;
    localStorage.user = JSON.stringify(data);
  },
  checkUser: function () {
    const u = window.myApp.user;
    console.log(u);
    return (u.name && u.lastname && u.sex && u.birthdate && u.birthdate !== '0000-00-00' && u.termsAndAgreementClient * 1 === 1);
  },
  categories: {
    restaurant: {},
    bar: {},
    beach: {},
    disco: {},
    hotel: {},
  },
  iconBg: L.icon({
    iconUrl: 'static/markers/restaurant-4.png',
    iconSize: [32, 32],
    iconAnchor: [16, 28],
    popupAnchor: [0, 0]
  }),
  icons: {
    'subscription-0': {
      restaurant: L.icon({
        iconUrl: 'static/markers/restaurant-4.png',
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        popupAnchor: [0, 0]
      }),
      bar: L.icon({
        iconUrl: 'static/markers/bar-4.png',
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        popupAnchor: [0, 0]
      }),
      beach: L.icon({
        iconUrl: 'static/markers/beach-4.png',
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        popupAnchor: [0, 0]
      }),
      disco: L.icon({
        iconUrl: 'static/markers/disco-4.png',
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        popupAnchor: [0, 0]
      }),
    },
    'subscription-5': {
      restaurant: L.icon({
        iconUrl: 'static/markers/restaurant-4.png',
        iconSize: [38, 38],
        iconAnchor: [19, 38],
        popupAnchor: [0, 0]
      }),
      bar: L.icon({
        iconUrl: 'static/markers/bar-4.png',
        iconSize: [38, 38],
        iconAnchor: [19, 38],
        popupAnchor: [0, 0]
      }),
      beach: L.icon({
        iconUrl: 'static/markers/beach-4.png',
        iconSize: [38, 38],
        iconAnchor: [19, 38],
        popupAnchor: [0, 0]
      }),
      disco: L.icon({
        iconUrl: 'static/markers/disco-4.png',
        iconSize: [38, 38],
        iconAnchor: [19, 38],
        popupAnchor: [0, 0]
      }),
    },
    'subscription-10': {
      restaurant: L.icon({
        iconUrl: 'static/markers/restaurant.png',
        iconSize: [32, 50],
        iconAnchor: [0, 32],
        popupAnchor: [0, 0]
      }),
      bar: L.icon({
        iconUrl: 'static/markers/bar.png',
        iconSize: [32, 50],
        iconAnchor: [0, 32],
        popupAnchor: [0, 0]
      }),
      beach: L.icon({
        iconUrl: 'static/markers/beach.png',
        iconSize: [32, 50],
        iconAnchor: [0, 32],
        popupAnchor: [0, 0]
      }),
      disco: L.icon({
        iconUrl: 'static/markers/disco.png',
        iconSize: [32, 50],
        iconAnchor: [0, 32],
        popupAnchor: [0, 0]
      }),
    },
    'subscription-10-offer': {
      restaurant: L.icon({
        iconUrl: 'static/markers/restaurant-gold-offer.png',
        iconSize: [32, 50],
        iconAnchor: [0, 32],
        popupAnchor: [0, 0]
      }),
      bar: L.icon({
        iconUrl: 'static/markers/bar-gold-offer.png',
        iconSize: [32, 50],
        iconAnchor: [0, 32],
        popupAnchor: [0, 0]
      }),
      beach: L.icon({
        iconUrl: 'static/markers/beach-gold-offer.png',
        iconSize: [32, 50],
        iconAnchor: [0, 32],
        popupAnchor: [0, 0]
      }),
      disco: L.icon({
        iconUrl: 'static/markers/disco-gold-offer.png',
        iconSize: [32, 50],
        iconAnchor: [0, 32],
        popupAnchor: [0, 0]
      }),
    },
  },
};

// lingua di default: en
window.lng = window.lng || lang.en;

var app = new Framework7({
  root: '#app', // App root element
  component: App, // App main component
  id: 'com.infomycity.infomycity', // App bundle ID
  name: 'InfoMyCity', // App name
  theme: 'ios', // md | ios | auto
  // App routes
  routes: routes,
  // Input settings
  input: {
    scrollIntoViewOnFocus: Framework7.device.cordova && !Framework7.device.electron,
    scrollIntoViewCentered: Framework7.device.cordova && !Framework7.device.electron,
  },
  // Cordova Statusbar settings
  statusbar: {
    iosOverlaysWebView: true,
    androidOverlaysWebView: false,
  },
  data() {
    return {
      type: '',
      subtypes: [],
    };
  },
  on: {
    init: function () {
      var f7 = this;
      // cordovaAppInit
      if (f7.device.cordova) {
        cordovaApp.init(f7);
      }
      server.app = f7;

      // Set language
      var l;
      if (localStorage.currentLanguage) {
        l = localStorage.currentLanguage;
        window.lng = lang[l];
      } else if (navigator.language) {
        l = navigator.language.substr(0, 2);
        window.lng = lang[l];
        localStorage.currentLanguage = l;
      } else {
        l = 'en';
      }

      // get user
      if (myApp.user.id) {
        myApp.server.get('imc/user/' + myApp.user.id).then(succ => {
          myApp.setUser(succ);
        }).catch(err => {
          console.log(err);
        });
      }

      // get categories
      myApp.server.get('imc/categories/' + l).then(categories => {
        myApp.categories = categories;
      });
    },
  },
});

